/**
 * Offline with no signed-in user to fall back on. Claims nothing about whether
 * this device has been signed into before: sign-out purges the cached user, so
 * a funder who signs out while offline lands here too.
 */
export function OfflineSignInGate() {
  return (
    <div className="p-sa-6 flex h-full items-center justify-center text-center">
      <div className="flex flex-col gap-2">
        <div className="font-medium">You're offline</div>
        <div className="text-sm text-muted-foreground">
          You'll need an internet connection to sign in.
        </div>
      </div>
    </div>
  );
}
